import { Link } from 'react-router-dom';
import CardGlyph from '@/pages/composer/components/CardGlyph';
import { formatPrice, marketplacePath, type MarketplaceCard } from '../mapPlaybook';

export default function PlaybookCard({ playbook }: { playbook: MarketplaceCard }) {
  return (
    <Link
      to={marketplacePath(playbook)}
      data-testid="marketplace-card"
      className="group w-full text-left bg-surface border border-border rounded-xl overflow-hidden hover:border-accentLine transition-colors flex flex-col"
    >
      <CardGlyph
        kind="playbook"
        category={playbook.category}
        title={playbook.name}
        steps={playbook.steps}
        inCount={0}
        outCount={0}
      />

      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-start justify-between gap-3">
          <p className="text-sm text-texts line-clamp-1">{playbook.tagline}</p>
          <span className="shrink-0 text-sm font-mono text-success">{playbook.score.toFixed(1)}/12</span>
        </div>

        <div className="mt-4 flex items-center gap-2 flex-wrap">
          {playbook.tags.map((t) => (
            <span
              key={t}
              className="whitespace-nowrap text-xs text-texts bg-surface2 border border-border px-2 py-0.5 rounded-full"
            >
              {t}
            </span>
          ))}
        </div>

        <div className="mt-5 pt-4 border-t border-border flex items-center justify-between gap-3">
          <div className="flex items-center gap-2.5 min-w-0">
            <span className="w-7 h-7 shrink-0 rounded-full bg-surface2 border border-border flex items-center justify-center text-xs font-medium text-texts">
              {playbook.authorInitials}
            </span>
            <div className="min-w-0">
              <div className="text-xs font-medium text-textp truncate">{playbook.author}</div>
              <div className="flex items-center gap-1 text-xs text-texts">
                <i className="ri-download-2-line text-[11px]" />
                <span>{playbook.downloads}</span>
              </div>
            </div>
          </div>

          <div className="shrink-0 flex items-center gap-2">
            <span className="whitespace-nowrap text-sm font-semibold text-textp">{formatPrice(playbook.priceCents)}</span>
            <span className="whitespace-nowrap inline-flex items-center gap-1.5 text-sm font-medium text-accent-text bg-accent group-hover:bg-accent-hover px-3 py-1.5 rounded-lg transition-colors">
              <i className="ri-download-2-line" />
              Get
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
